export enum ContractType {
  Hourly = "Hourly",
  HourlyPension = "HourlyPension",
  HourlyPensionInsurance = "HourlyPensionInsurance",
  NationalProcurement = "NationalProcurement"
}

export const CONTRACT_TYPE_CONST = {
  HourlyPension: 1.045,
  Insurance: 6
};

export enum CustomerContractAgreementType {
  Procured = "Procured",
  NotProcured = "NotProcured"
}

export enum CustomerContractCompany {
  Bonliva_AB = "Bonliva_AB",
  Bonliva_Care = "Bonliva_Care"
}

export enum CustomerContractDocumentTypes {
  Agreement = "Agreement",
  ContractAttachments = "ContractAttachments",
  PricesOB = "PricesOB",
  SubVersion = "SubVersion",
  Other = "Other"
}

export enum CustomerContractStatus {
  Active = "Active",
  Completed = "Completed",
  Coming = "Coming",
  Deleted = "Deleted"
}

export enum CustomerContractSnapshotTypes {
  Framework = "Framework",
  Confirmation = "Confirmation"
}
